import axios from "axios";

export const getHome = async () => {
  try {
    const home = axios({
      url: `${process.env.REACT_APP_API_URL}/pages/home`,
      method: "GET",
    });
    return home;
  } catch (err) {
    return err;
  }
};
